import { MyCalendar } from "components";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";

const Calendar = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    return (
        <section className="w-full flex flex-col relative px-4 py-4 md:px-10 md:py-10">
            <div className="w-full text-center">
                <Breadcrumb breadcrumb={breadcrumb} currentPath="Calendar" />
            </div>
            <div className="w-full overflow-auto px-3 md:px-5 lg:px-10">
                <MyCalendar />
            </div>
        </section>
    );
};

export default Calendar;
